import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import MealPlanSection from "@/features/meal-plan/components/MealPlanSection"
import FolderCard from "@/features/shared/components/FolderCard"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { saveEvent } from "../../../utils/apis/user-service"
import { EventType } from "../../../utils/enums/EventType"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { usePlansStore } from "../../../utils/stores/usePlansStore"
import { useUserStore } from "../../../utils/stores/useUserStore"

const MealPlan = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const { userData } = useUserStore()
    const email = userData.email
    const { plans } = usePlansStore()
    const mealPlans = plans.mealPlans
    const healthPlans = plans.healthPlans
    const navigate = useNavigate()

    useEffect(() => {
        if (!email || !idToken) return

        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "meal_plan_page"
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "meal_plan_page",
            event_metadata: { meal_plan_available: mealPlans !== null }
        })
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col  max-w-[1068px]">
            {/* <div className="mt-[10px] space-y-[10px]">
                <BackButton
                    text="Torna a Health Plan"
                    onClick={() => navigate("/health-plan")}
                />
                <div className="font-bold text-[25px] leading-[33px]">
                    Meal Plan
                </div>
            </div> */}
            <div className="space-y-[20px] pb-[20px]">
                {
                    mealPlans && <MealPlanSection mealPlan={mealPlans[0]} healthPlan={healthPlans ? healthPlans[0] : null} />
                }
                {
                    mealPlans && mealPlans.length > 1 &&
                    <div className="space-y-[20px]">
                        <div className="w-full h-[1px] bg-black" />
                            <FolderCard
                                onClick={() => navigate("/meal-plan-history") }
                                title="Meal Plan passati"
                            />
                    </div>
                }
            </div>
        </div>
    )
}

export default MealPlan
